import axios from "axios";
import { getToken, removeToken } from "../../utils/helpers";

export const API_URL = process.env.REACT_APP_API_URL;
export const getApiUrl = () => `${API_URL}/api/v1`;

export const apiClient = axios.create({
  baseURL: getApiUrl(),
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Accept-Language": "ka-GE",
    "Application-Type": "Web",
    "FCM-Token": "DeviceId",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token && config?.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log("request error", error);
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (resp) => resp,
  (err) => {
    console.log(err);
    if (err.response.status.toString() === "401") {
      removeToken();
    }
    //remove token from localstorage
    //redirect to login
  },
);
